import { useNavigate } from 'react-router-dom';
import * as hook from '../hooks/export';
import * as style from '../utils/general_style';
import * as links from '../utils/general_links';
import { allInputs } from '../utils/form_data';
import inputValidator from '../utils/form_functions';
import * as form from '../components/form/export';

function EspacePro() {
    const page = 'espacepro'
    const [checked, setChecked] = hook.useCheckState();

    const inputs = allInputs.filter(input => input.forms.includes(page));

    if (sessionStorage.getItem(`${page}_subject`) === null || sessionStorage.getItem(`${page}_subject`) === '') {
        sessionStorage.setItem(`${page}_subject`, `Demande d'adhésion`);
    }

    const saveInputValue = (e) => {
        sessionStorage.setItem(`${page}_${e.target.name}`, e.target.value);
    };

    const [validationState, setValidationState] = hook.useValidationState(inputs)
    const validateInputData = (e) => {
        let isValidated = inputValidator(e.target.name, e.target.value);
        setValidationState(prevState => ({...prevState, [e.target.name]: isValidated}));
    };

    const isValidated = (type, name) => {
        let validate;
        if (type === 'devided') {
            validate = (validationState['codePostal'] && validationState['ville']) ? '0' : '1';
        } else {
            validate = validationState[name] ? '0' : '1';
        }
        return validate;
    }

    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault();
        setTimeout(function() {
            navigate(links.ROUTES.home)
        }, 800);
    };

	return (
        <div className='AppBody noCTABar'>
			<section style={style.ELEMENT_BLOCK_WHITE}>
                <form>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>Se connecter</legend>
                        <div style={{width: '94px', height: '94px', position: 'relative', marginBottom: style.SPACE.extraLarge}}><i className="fa-solid fa-user-large" style={{fontSize: '92px', position: 'absolute', top: '0', left: '0', color: style.COLORS.primary, filter: `drop-shadow(0px 4px 4px ${style.COLORS.secondary_trans})`}}></i></div>
                        <div style={{margin: `${style.SPACE.medium} 0px`}}><a href="https://www.presentis.fr/login_partenaire" target="_blank" rel="noreferrer" style={{cursor: 'pointer'}}>Se rendre sur&nbsp;<u>Presentis.fr</u><i className="fa-solid fa-arrow-pointer fa-beat-fade fa-xs" style={{position: 'relative', top: '10px'}}></i></a></div>
                    </fieldset>
                </form>
            </section>
            <section style={style.ELEMENT_BLOCK_WHITE}>
                <form method='post' onSubmit={ handleSubmit }>
                    <fieldset style={{...style.FIELDSET, ...style.COLUMN_CENTER}}>
                        <legend style={style.LEGEND}>Demande d'adhésion</legend>
                        <div style={{width: '94px', height: '94px', position: 'relative', marginBottom: style.SPACE.large}}><i className="fa-solid fa-pen-to-square" style={{fontSize: '92px', position: 'absolute', top: '0', left: '0', color: style.COLORS.primary, filter: `drop-shadow(0px 4px 4px ${style.COLORS.secondary_trans})`}}></i></div>
                        <div style={{...style.ROW_SPACE_BETWEEN, width: '100%', flexWrap: 'wrap'}}>
                            {inputs.map(({ label, name, type, required, options, devidedInputs }, index) => (
                                <form.CustomInput label={ label } type={ type } name={ name } required={ required } onChange={ saveInputValue } onBlur={ e => validateInputData(e) } validationState={ isValidated(type, name) } keyword={ page } form={ page } options={ options } devidedInputs={ devidedInputs } size={ (inputs.length === index + 1 && ((index + 1) % 2) !== 0) ? 'full' : '' } key={ index } />
                            ))}
                        </div>
                        <div style={{cursor: 'pointer', margin: `${style.SPACE.medium} 0px`}}>
                            <form.Checkbox id='membershipConditions' checked={ checked } onChange={ setChecked } label={<p style={{fontSize: '14px', textAlign: 'center'}}>En soumettant ce formulaire, j'accepte que les informations saisies soient utilisées pour me recontacter, je reconnais avoir pris connaissance de votre politique de confidentialité et j'accepte les conditions générales de vente.</p>} />
                        </div>
                        <div style={{...style.ROW_CENTER, width: '100%', margin: `${style.SPACE.medium} 0px`}}>
                            <form.SubmitButton label={'Envoi'} clear={ page } />
                        </div>
                    </fieldset>
                    <div style={{...style.ROW_END, margin: `${style.SPACE.small} 0px`}}>
                        <form.RequiredSpan required={ true } /><p>informations requises</p>
                    </div>
                </form>
            </section>
        </div>
	);
};

export default EspacePro;